// ========================================
// NEW AD SECTION - 100% LIVE PAGE COMPATIBLE
// ========================================
//
// ===============================================================
// PERF-FIX (NO_LCP) — 2 changes in this file. Search for "PERF-FIX"
//   1. initializeVideoCarousel  (~line 690)  — unbounded retry loop capped
//   2. initFeatureCarouselSync  (~line 1560) — unbounded retry loop capped
// Both original versions are kept directly above each fix, commented out,
// so you can revert by swapping the comment markers.
// ===============================================================

// Global error handler for maximum compatibility
// window.addEventListener('error', function(e) {
//   console.error('Global error caught:', e.error);
// });

// Additional error handling for unhandled promise rejections
window.addEventListener('unhandledrejection', function(e) {
  console.error('Unhandled promise rejection:', e.reason);
});

// Utility function to safely get elements with enhanced error handling
function safeQuerySelector(selector, parent = document) {
  try {
      if (!selector || typeof selector !== 'string') {
          console.warn('Invalid selector provided:', selector);
          return null;
      }
      const element = parent.querySelector(selector);
      return element || null; // return null silently
  } catch (error) {
      console.error(`Error finding element ${selector}:`, error);
      return null;
  }
}


function safeQuerySelectorAll(selector, parent = document) {
  try {
    if (!selector || typeof selector !== 'string') return [];
    return parent.querySelectorAll(selector) || [];
  } catch {
    return [];
  }
}
// Enhanced initialization check function
function isElementReady(selector, maxAttempts = 10) {
  return new Promise((resolve) => {
      let attempts = 0;
      const checkElement = () => {
          const element = safeQuerySelector(selector);
          if (element) {
              resolve(true);
          } else if (attempts < maxAttempts) {
              attempts++;
              setTimeout(checkElement, 100);
          } else {
              console.warn(`Element ${selector} not ready after ${maxAttempts} attempts`);
              resolve(false);
          }
      };
      checkElement();
  });
}


// ========================================
// FEATURE CAROUSEL SECTION
// ========================================


let currentSlide = 0;
const totalSlides = 8;


function showSlide(slideIndex) {
  try {
      // Validate input
      if (slideIndex < 0 || slideIndex >= totalSlides) {
          console.warn(`Invalid slide index: ${slideIndex}`);
          return;
      }


      const slides = safeQuerySelectorAll('.feature-carousel-slide');
      const buttons = safeQuerySelectorAll('.feature-button');
      const dots = safeQuerySelectorAll('.carousel-nav-dot');


      // Remove active class from all slides
      slides.forEach(slide => {
          if (slide) slide.classList.remove('active');
      });


      // Remove active class from all buttons
      buttons.forEach(btn => {
          if (btn) btn.classList.remove('active');
      });


      // Remove active class from all dots
      dots.forEach(dot => {
          if (dot) dot.classList.remove('active');
      });


      // Activate target slide
      const targetSlide = safeQuerySelector(`[data-slide="${slideIndex}"]`);
      if (targetSlide) {
          targetSlide.classList.add('active');
      }


      // Activate target button
      const targetButton = safeQuerySelector(`[data-target="${slideIndex}"]`);
      if (targetButton) {
          targetButton.classList.add('active');
      }


      // Activate target dot
      if (dots[slideIndex]) {
          dots[slideIndex].classList.add('active');
      }


      currentSlide = slideIndex;
      console.log(`Slide changed to: ${slideIndex}`);
  } catch (error) {
      console.error('Error in showSlide:', error);
  }
}


function showNextSlide() {
  const nextSlide = (currentSlide + 1) % totalSlides;
  showSlide(nextSlide);
}


function showPreviousSlide() {
  const prevSlide = (currentSlide - 1 + totalSlides) % totalSlides;
  showSlide(prevSlide);
}


// Make functions globally available
window.showSlide = showSlide;
window.showNextSlide = showNextSlide;
window.showPreviousSlide = showPreviousSlide;


// ========================================
// TESTIMONIAL CAROUSEL SECTION
// ========================================


let currentTestimonialCategory = 'mental-health';
let currentSubSlide = 0;
const totalSubSlides = 3;


function showTestimonialCategory(category) {
  try {
      console.log(`Switching to category: ${category}`);
     
      // Remove active class from all category buttons
      const categoryButtons = safeQuerySelectorAll('.category-btn');
      categoryButtons.forEach(btn => {
          if (btn) btn.classList.remove('active');
      });
     
      // Add active class to clicked button
      const activeButton = safeQuerySelector(`.category-btn[data-category="${category}"]`);
      if (activeButton) {
          activeButton.classList.add('active');
      } else {
          console.warn(`Category button not found: ${category}`);
      }
     
      // Hide all category slides
      const categorySlides = safeQuerySelectorAll('.testimonial-category-slide');
      categorySlides.forEach(slide => {
          if (slide) slide.classList.remove('active');
      });
     
      // Show the selected category slide
      const targetSlide = safeQuerySelector(`.testimonial-category-slide[data-category="${category}"]`);
      if (targetSlide) {
          targetSlide.classList.add('active');
          // Reset sub slide to first slide when changing categories
          currentSubSlide = 0;
          showSubSlide(0);
      } else {
          console.warn(`Category slide not found: ${category}`);
      }
     
      currentTestimonialCategory = category;
  } catch (error) {
      console.error('Error in showTestimonialCategory:', error);
  }
}


function showSubSlide(subSlideIndex) {
  try {
      const activeCategorySlide = safeQuerySelector('.testimonial-category-slide.active');
      if (!activeCategorySlide) {
          console.warn('No active category slide found');
          return;
      }
     
      // Check if this is the new case study section
      const isNewCaseStudy = activeCategorySlide.closest('.new-case-study-section');
     
      // Remove active class from all sub slides
      const subSlides = safeQuerySelectorAll('.testimonial-sub-slide, .testimonial-sub-carousel .col', activeCategorySlide);
      subSlides.forEach(slide => {
          if (slide) slide.classList.remove('active');
      });
     
      // Remove active class from all sub indicators
      const subIndicators = safeQuerySelectorAll('.sub-indicator', activeCategorySlide);
      subIndicators.forEach(indicator => {
          if (indicator) indicator.classList.remove('active');
      });
     
      // Show the target sub slide
      const targetSubSlide = safeQuerySelector(`[data-sub-slide="${subSlideIndex}"]`, activeCategorySlide);
      if (targetSubSlide) {
          targetSubSlide.classList.add('active');
      } else {
          // For new case study section, target the col elements directly
          const colSlides = safeQuerySelectorAll('.testimonial-sub-carousel .col', activeCategorySlide);
          if (colSlides[subSlideIndex]) {
              colSlides[subSlideIndex].classList.add('active');
          }
      }
     
      // Activate the target indicator
      if (subIndicators[subSlideIndex]) {
          subIndicators[subSlideIndex].classList.add('active');
      }
     
      currentSubSlide = subSlideIndex;
      console.log(`Sub slide changed to: ${subSlideIndex}`);
  } catch (error) {
      console.error('Error in showSubSlide:', error);
  }
}


function showNextTestimonialSlide() {
  const nextSubSlide = (currentSubSlide + 1) % totalSubSlides;
  showSubSlide(nextSubSlide);
}


function showPreviousTestimonialSlide() {
  const prevSubSlide = (currentSubSlide - 1 + totalSubSlides) % totalSubSlides;
  showSubSlide(prevSubSlide);
}


function openCaseStudy() {
  console.log('Opening case study...');
  // Add your case study functionality here
}


// Make functions globally available
window.showTestimonialCategory = showTestimonialCategory;
window.showSubSlide = showSubSlide;
window.showNextTestimonialSlide = showNextTestimonialSlide;
window.showPreviousTestimonialSlide = showPreviousTestimonialSlide;
window.openCaseStudy = openCaseStudy;




let currentSubIndex = 0;

function showSubSlide(index) {
    const activeCategory = document.querySelector('.testimonial-category-slide.active');
    const slides = activeCategory.querySelectorAll('.testimonial-sub-slide');
    const indicators = activeCategory.querySelectorAll('.sub-indicator');

    // loop back if out of range
    if (index >= slides.length) index = 0;
    if (index < 0) index = slides.length - 1;

    // update active index
    currentSubIndex = index;

    // hide all slides
    slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
    });

    // update indicators
    indicators.forEach((btn, i) => {
        btn.classList.toggle('active', i === index);
    });
}

function showNextTestimonialSlide() {
    showSubSlide(currentSubIndex + 1);
}

function showPreviousTestimonialSlide() {
    showSubSlide(currentSubIndex - 1);
}

// ========================================
// AUTO-SCROLLING TESTIMONIAL SECTION
// ========================================


(function () {
  const AUTO_SLIDE_DELAY = 80000;
  let currentSubSlide = 0;
  let subSlides = [];
  let indicators = [];
  let totalSubSlides = 0;
  let autoSlideInterval;
  let touchStartX = 0;
  let touchEndX = 0;


  function showSubSlide(index) {
      try {
          const activeCategorySlide = safeQuerySelector('.testimonial-category-slide.active');
          if (!activeCategorySlide) return;


          subSlides = safeQuerySelectorAll('.testimonial-sub-slide', activeCategorySlide);
          indicators = safeQuerySelectorAll('.sub-indicator', activeCategorySlide);
          totalSubSlides = subSlides.length;


          if (totalSubSlides === 0) return;


          subSlides.forEach(slide => {
              if (slide) slide.classList.remove('active');
          });
          indicators.forEach(dot => {
              if (dot) dot.classList.remove('active');
          });


          if (subSlides[index]) subSlides[index].classList.add('active');
          if (indicators[index]) indicators[index].classList.add('active');


          currentSubSlide = index;
      } catch (error) {
          console.error('Error in auto-slide showSubSlide:', error);
      }
  }


  function nextSubSlide() {
      if (totalSubSlides > 0) {
          const next = (currentSubSlide + 1) % totalSubSlides;
          showSubSlide(next);
      }
  }


  function prevSubSlide() {
      if (totalSubSlides > 0) {
          const prev = (currentSubSlide - 1 + totalSubSlides) % totalSubSlides;
          showSubSlide(prev);
      }
  }


  function setupSwipe(slideWrapper) {
      try {
          if (!slideWrapper) return;
         
          // Remove existing event listeners to prevent duplicates
          slideWrapper.removeEventListener('touchstart', handleTouchStart);
          slideWrapper.removeEventListener('touchend', handleTouchEnd);
         
          // Add new event listeners
          slideWrapper.addEventListener('touchstart', handleTouchStart);
          slideWrapper.addEventListener('touchend', handleTouchEnd);
      } catch (error) {
          console.error('Error in setupSwipe:', error);
      }
  }


  function handleTouchStart(e) {
      try {
          touchStartX = e.changedTouches[0].screenX;
      } catch (error) {
          console.error('Error in handleTouchStart:', error);
      }
  }


  function handleTouchEnd(e) {
      try {
          touchEndX = e.changedTouches[0].screenX;
          if (touchEndX < touchStartX - 40) nextSubSlide();
          if (touchEndX > touchStartX + 40) prevSubSlide();
      } catch (error) {
          console.error('Error in handleTouchEnd:', error);
      }
  }


  function startAutoSlide() {
      try {
          if (window.innerWidth < 1340) {
              clearInterval(autoSlideInterval);
              autoSlideInterval = setInterval(nextSubSlide, AUTO_SLIDE_DELAY);
          }
      } catch (error) {
          console.error('Error in startAutoSlide:', error);
      }
  }


  function stopAutoSlide() {
      try {
          clearInterval(autoSlideInterval);
      } catch (error) {
          console.error('Error in stopAutoSlide:', error);
      }
  }


  function initTestimonialMobileSlider() {
      try {
          if (window.innerWidth >= 1340) {
              stopAutoSlide();
              return;
          }


          const activeCategorySlide = safeQuerySelector('.testimonial-category-slide.active');
          if (!activeCategorySlide) return;


          subSlides = safeQuerySelectorAll('.testimonial-sub-slide', activeCategorySlide);
          indicators = safeQuerySelectorAll('.sub-indicator', activeCategorySlide);
          totalSubSlides = subSlides.length;


          if (totalSubSlides === 0) return;


          showSubSlide(0); // show first
          startAutoSlide();
          setupSwipe(activeCategorySlide);
      } catch (error) {
          console.error('Error in initTestimonialMobileSlider:', error);
      }
  }


  // Initialize on page load
  window.addEventListener('load', initTestimonialMobileSlider);
  window.addEventListener('resize', initTestimonialMobileSlider);


  // Override functions for mobile
  const originalShowTestimonialCategory = window.showTestimonialCategory;
  window.showTestimonialCategory = function(category) {
      try {
          originalShowTestimonialCategory(category);
          if (window.innerWidth < 1340) {
              setTimeout(initTestimonialMobileSlider, 100);
          }
      } catch (error) {
          console.error('Error in overridden showTestimonialCategory:', error);
      }
  };


  const originalShowSubSlide = window.showSubSlide;
  window.showSubSlide = function (index) {
      try {
          originalShowSubSlide(index);
          if (window.innerWidth < 1340) {
              clearInterval(autoSlideInterval);
              autoSlideInterval = setInterval(nextSubSlide, AUTO_SLIDE_DELAY);
          }
      } catch (error) {
          console.error('Error in overridden showSubSlide:', error);
      }
  };
})();


// ========================================
// SPECIALTY SECTION
// ========================================


function showSpeciality(speciality) {
  try {
      console.log(`Switching to specialty: ${speciality}`);
     
      // Remove active class from all specialty buttons
      const allButtons = safeQuerySelectorAll('.speciality-btn');
      allButtons.forEach(btn => {
          if (btn) btn.classList.remove('active');
      });


      // Add active class to clicked button
      const activeButton = safeQuerySelector(`.speciality-btn[data-speciality="${speciality}"]`);
      if (activeButton) {
          activeButton.classList.add('active');
      } else {
          console.warn(`Specialty button not found: ${speciality}`);
      }


      // Hide all specialty content
      const allContent = safeQuerySelectorAll('.speciality-content');
      allContent.forEach(content => {
          if (content) content.classList.remove('active');
      });


      // Show the selected specialty content
      const selectedContent = safeQuerySelector(`.speciality-content[data-speciality="${speciality}"]`);
      if (selectedContent) {
          selectedContent.classList.add('active');
      } else {
          console.warn(`Specialty content not found: ${speciality}`);
      }
  } catch (error) {
      console.error('Error in showSpeciality:', error);
  }
}


// Make function globally available
window.showSpeciality = showSpeciality;


// ========================================
// VIDEO CAROUSEL SECTION - ENHANCED FOR LIVE PAGES
// ========================================

(function() {
  try {
      // Wait for DOM to be ready
      function initVideoCarousel() {
          console.log('Initializing video carousel...');
          
          const videoModal = safeQuerySelector('#videoModal');
          const modalVideo = safeQuerySelector('#modalVideo');
          const modalClose = safeQuerySelector('#modalClose');
          const playButtons = safeQuerySelectorAll('.play-button');
          const carouselTrack = safeQuerySelector('.video-carousel-track');

          if (!videoModal || !modalVideo || !modalClose) {
              console.warn('Video modal elements not found:', {
                  videoModal: !!videoModal,
                  modalVideo: !!modalVideo,
                  modalClose: !!modalClose
              });
              return;
          }

          console.log('Found play buttons:', playButtons.length);

          // Open modal when play button is clicked
          playButtons.forEach((button, index) => {
              if (button) {
                  console.log(`Setting up play button ${index + 1}`);
                  
                  // Remove existing listeners to prevent duplicates
                  button.removeEventListener('click', button._videoClickHandler);
                  
                  // Create new click handler
                  button._videoClickHandler = function(e) {
                      try {
                          console.log('Play button clicked');
                          e.preventDefault();
                          e.stopPropagation();
                          
                          const card = this.closest('.video-card');
                          if (!card) {
                              console.warn('No video card found');
                              return;
                          }
                         
                          const videoSrc = card.getAttribute('data-video');
                          const videoTitle = card.getAttribute('data-title');
                         
                          console.log('Video source:', videoSrc);
                          console.log('Video title:', videoTitle);
                         
                          if (videoSrc) {
                              // Set video source and attributes for better compatibility
                              modalVideo.src = videoSrc;
                              modalVideo.preload = 'metadata';
                              modalVideo.controls = true;
                              modalVideo.muted = false;
                              modalVideo.load(); // Ensure video loads
                              
                              // Show modal
                              videoModal.classList.add('active');
                              document.body.style.overflow = 'hidden'; // Prevent background scroll
                             
                              if (carouselTrack) {
                                  carouselTrack.style.animationPlayState = 'paused';
                              }
                              
                              // Enhanced video play with multiple strategies for live pages
                              playVideoWithEnhancedFallback(modalVideo, videoModal);
                          } else {
                              console.warn('No video source found');
                          }
                      } catch (error) {
                          console.error('Error opening video modal:', error);
                      }
                  };
                  
                  button.addEventListener('click', button._videoClickHandler);
              }
          });

          // Close modal with enhanced functionality
          if (modalClose) {
              modalClose.removeEventListener('click', modalClose._closeHandler);
              modalClose._closeHandler = function() {
                  try {
                      console.log('Closing video modal');
                      closeVideoModal(videoModal, modalVideo, carouselTrack);
                  } catch (error) {
                      console.error('Error closing video modal:', error);
                  }
              };
              modalClose.addEventListener('click', modalClose._closeHandler);
          }

          // Close modal when clicking outside
          videoModal.removeEventListener('click', videoModal._outsideClickHandler);
          videoModal._outsideClickHandler = function(e) {
              try {
                  if (e.target === videoModal) {
                      console.log('Closing video modal (outside click)');
                      closeVideoModal(videoModal, modalVideo, carouselTrack);
                  }
              } catch (error) {
                  console.error('Error closing video modal (outside click):', error);
              }
          };
          videoModal.addEventListener('click', videoModal._outsideClickHandler);

          // Close modal with Escape key
          document.removeEventListener('keydown', document._escapeHandler);
          document._escapeHandler = function(e) {
              try {
                  if (e.key === 'Escape' && videoModal.classList.contains('active')) {
                      console.log('Closing video modal (Escape key)');
                      closeVideoModal(videoModal, modalVideo, carouselTrack);
                  }
              } catch (error) {
                  console.error('Error closing video modal (Escape):', error);
              }
          };
          document.addEventListener('keydown', document._escapeHandler);

          // Pause carousel on hover
          if (carouselTrack) {
              carouselTrack.removeEventListener('mouseenter', carouselTrack._pauseHandler);
              carouselTrack._pauseHandler = function() {
                  try {
                      this.style.animationPlayState = 'paused';
                  } catch (error) {
                      console.error('Error pausing carousel:', error);
                  }
              };
              carouselTrack.addEventListener('mouseenter', carouselTrack._pauseHandler);

              carouselTrack.removeEventListener('mouseleave', carouselTrack._resumeHandler);
              carouselTrack._resumeHandler = function() {
                  try {
                      if (!videoModal.classList.contains('active')) {
                          this.style.animationPlayState = 'running';
                      }
                  } catch (error) {
                      console.error('Error resuming carousel:', error);
                  }
              };
              carouselTrack.addEventListener('mouseleave', carouselTrack._resumeHandler);
          }
          
          console.log('Video carousel initialized successfully');
      }

      // Enhanced video play function with multiple fallbacks for live pages
      function playVideoWithEnhancedFallback(videoElement, modalElement) {
          try {
              console.log('Attempting to play video with enhanced fallback...');
              
              // Strategy 1: Direct play with user interaction
              const playPromise = videoElement.play();
              
              if (playPromise !== undefined) {
                  playPromise.then(() => {
                      console.log('Video started playing successfully on first attempt');
                  }).catch(error => {
                      console.log('Autoplay prevented, trying enhanced fallback strategies:', error);
                      
                      // Strategy 2: Show enhanced play button overlay
                      showEnhancedPlayButtonOverlay(videoElement, modalElement);
                      
                      // Strategy 3: Add click-to-play functionality to video element
                      videoElement.style.cursor = 'pointer';
                      videoElement.title = 'Click to play video';
                      
                      const videoClickHandler = function() {
                          videoElement.play().then(() => {
                              console.log('Video started playing on video click');
                              videoElement.style.cursor = 'default';
                              videoElement.title = '';
                              videoElement.removeEventListener('click', videoClickHandler);
                          }).catch(err => {
                              console.error('Failed to play on video click:', err);
                          });
                      };
                      
                      videoElement.addEventListener('click', videoClickHandler);
                      
                      // Strategy 4: Add play button inside modal
                      addModalPlayButton(videoElement, modalElement);
                  });
              } else {
                  // Fallback for browsers that don't return a promise
                  console.log('No play promise returned, showing play overlay');
                  showEnhancedPlayButtonOverlay(videoElement, modalElement);
              }
          } catch (error) {
              console.error('Error in playVideoWithEnhancedFallback:', error);
              // Final fallback
              showEnhancedPlayButtonOverlay(videoElement, modalElement);
          }
      }

      // Enhanced play button overlay for manual play
      function showEnhancedPlayButtonOverlay(videoElement, modalElement) {
          try {
              // Remove existing overlay if any
              const existingOverlay = modalElement.querySelector('.modal-play-overlay');
              if (existingOverlay) {
                  existingOverlay.remove();
              }
              
              // Create enhanced play button overlay
              const playOverlay = document.createElement('div');
              playOverlay.className = 'modal-play-overlay';
              playOverlay.innerHTML = `
                  <div class="play-button-overlay">
                      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 5V19L19 12L8 5Z" fill="white"/>
                      </svg>
                      <p>Click to play video</p>
                      <small>Autoplay is disabled in your browser</small>
                  </div>
              `;
              
              // Insert overlay into modal
              const modalContent = modalElement.querySelector('.modal-content');
              if (modalContent) {
                  modalContent.appendChild(playOverlay);
              }
              
              // Add click handler to overlay
              playOverlay.addEventListener('click', function() {
                  console.log('Play overlay clicked, attempting to play video');
                  
                  // Try multiple play strategies
                  const playStrategies = [
                      () => videoElement.play(),
                      () => {
                          videoElement.muted = true;
                          return videoElement.play().then(() => {
                              videoElement.muted = false;
                              return videoElement.play();
                          });
                      },
                      () => {
                          videoElement.currentTime = 0;
                          return videoElement.play();
                      }
                  ];
                  
                  let strategyIndex = 0;
                  
                  const tryNextStrategy = () => {
                      if (strategyIndex < playStrategies.length) {
                          const strategy = playStrategies[strategyIndex];
                          strategy().then(() => {
                              console.log(`Video started playing with strategy ${strategyIndex + 1}`);
                              playOverlay.style.display = 'none';
                          }).catch(err => {
                              console.log(`Strategy ${strategyIndex + 1} failed:`, err);
                              strategyIndex++;
                              tryNextStrategy();
                          });
                      } else {
                          console.error('All play strategies failed');
                          playOverlay.innerHTML = `
                              <div class="play-button-overlay">
                                  <p>Unable to play video</p>
                                  <small>Please try refreshing the page</small>
                              </div>
                          `;
                      }
                  };
                  
                  tryNextStrategy();
              });
              
              console.log('Enhanced play button overlay created');
          } catch (error) {
              console.error('Error showing enhanced play button overlay:', error);
          }
      }

      // Add play button inside modal as additional fallback
      function addModalPlayButton(videoElement, modalElement) {
          try {
              // Create a play button inside the modal
              const playButton = document.createElement('button');
              playButton.className = 'modal-play-button';
              playButton.innerHTML = `
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 5V19L19 12L8 5Z" fill="white"/>
                  </svg>
                  Play Video
              `;
              playButton.style.cssText = `
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  background: rgba(0, 0, 0, 0.8);
                  color: white;
                  border: none;
                  border-radius: 8px;
                  padding: 12px 24px;
                  cursor: pointer;
                  z-index: 1002;
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  font-family: Manrope;
                  font-size: 16px;
                  font-weight: 600;
              `;
              
              const modalContent = modalElement.querySelector('.modal-content');
              if (modalContent) {
                  modalContent.appendChild(playButton);
                  
                  playButton.addEventListener('click', function() {
                      videoElement.play().then(() => {
                          console.log('Video started playing from modal play button');
                          playButton.style.display = 'none';
                      }).catch(err => {
                          console.error('Failed to play from modal play button:', err);
                      });
                  });
              }
          } catch (error) {
              console.error('Error adding modal play button:', error);
          }
      }

      // Enhanced close modal function
      function closeVideoModal(modal, video, carouselTrack) {
          try {
              console.log('Closing video modal');
              
              // Hide modal
              modal.classList.remove('active');
              document.body.style.overflow = ''; // Restore scroll
              
              // Pause and clear video
              video.pause();
              video.src = '';
              video.load();
              video.style.cursor = 'default';
              video.title = '';
              
              // Remove all play overlays and buttons
              const playOverlays = modal.querySelectorAll('.modal-play-overlay, .modal-play-button');
              playOverlays.forEach(overlay => overlay.remove());
              
              // Resume carousel
              if (carouselTrack) {
                  carouselTrack.style.animationPlayState = 'running';
              }
              
              console.log('Video modal closed successfully');
          } catch (error) {
              console.error('Error closing video modal:', error);
          }
      }

      // Multiple initialization strategies for maximum compatibility

      // ============================================================
      // ===== PERF-FIX 1 of 2 — OLD CODE, COMMENTED OUT ============
      // WHY: this retried every 500ms FOREVER because #modalVideo does not
      // exist in the live DOM (it only exists inside an HTML comment in
      // custom-ehr-software-development.html). Four separate entry points below
      // each started their OWN chain, so ~3 timers fired ~6x/second for as long
      // as the tab stayed open. Lighthouse waits for the page to go quiet before
      // ending its trace; a page that never goes quiet gets its trace cut, and
      // the LCP event goes missing => "NO_LCP" / Performance score "Error!".
      // TO REVERT: comment out the NEW CODE block below and uncomment this one.
      //
      // function initializeVideoCarousel() {
      //     try {
      //         const videoModal = safeQuerySelector('#videoModal');
      //         const modalVideo = safeQuerySelector('#modalVideo');
      //         const modalClose = safeQuerySelector('#modalClose');
      //         const playButtons = safeQuerySelectorAll('.play-button');
      //
      //         if (!videoModal || !modalVideo || !modalClose || playButtons.length === 0) {
      //             // retry silently, no warnings
      //             setTimeout(initializeVideoCarousel, 500);
      //             return;
      //         }
      //
      //         console.log('Initializing video carousel...');
      //         initVideoCarousel();
      //
      //     } catch (error) {
      //         console.error('Error in video carousel initialization:', error);
      //         setTimeout(initializeVideoCarousel, 1000);
      //     }
      // }
      // ===== END OLD CODE =========================================


      // ===== PERF-FIX 1 of 2 — NEW CODE ===========================
      // Same logic, but retries are capped and the counter is SHARED across all
      // four entry points, so the whole file makes at most 10 attempts (~5s
      // total) and then stops. _vcInitialized also guarantees initVideoCarousel()
      // can never bind its listeners twice.
      var _vcAttempts = 0;
      var _vcMaxAttempts = 10;
      var _vcInitialized = false;

      function initializeVideoCarousel() {
          if (_vcInitialized) return;

          try {
              var videoModal  = safeQuerySelector('#videoModal');
              var modalVideo  = safeQuerySelector('#modalVideo');
              var modalClose  = safeQuerySelector('#modalClose');
              var playButtons = safeQuerySelectorAll('.play-button');

              if (!videoModal || !modalVideo || !modalClose || playButtons.length === 0) {
                  if (_vcAttempts < _vcMaxAttempts) {
                      _vcAttempts++;
                      setTimeout(initializeVideoCarousel, 500);
                  }
                  // give up silently after the cap — no infinite loop
                  return;
              }

              _vcInitialized = true;
              initVideoCarousel();

          } catch (error) {
              console.error('Error in video carousel initialization:', error);
              if (_vcAttempts < _vcMaxAttempts) {
                  _vcAttempts++;
                  setTimeout(initializeVideoCarousel, 1000);
              }
          }
      }
      // ===== END NEW CODE =========================================
      // ============================================================


      // Initialize with multiple strategies
      if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function() {
              console.log('DOMContentLoaded - Initializing video carousel...');
              setTimeout(initializeVideoCarousel, 100);
          });
      } else {
          console.log('Document already loaded - Initializing video carousel...');
          setTimeout(initializeVideoCarousel, 100);
      }
      
      // Window load backup
      window.addEventListener('load', function() {
          console.log('Window load - Backup video carousel initialization...');
          setTimeout(initializeVideoCarousel, 200);
      });
      
      // Additional backup for slow-loading pages
      setTimeout(function() {
          console.log('Delayed video carousel initialization check...');
          initializeVideoCarousel();
      }, 3000);
      
  } catch (error) {
      console.error('Error in video carousel functionality:', error);
  }



  
})();
 




// ========================================
// NEW CASE STUDY SECTION - SPECIFIC FUNCTIONALITY
// ========================================

(function () {
   const NEW_CASE_STUDY_AUTO_SLIDE_DELAY = 12000; // 12 seconds
   let newCaseStudyCurrentSubSlide = 0;
   let newCaseStudyCurrentCategory = 'mental-health-new';
   let newCaseStudySubSlides = [];
   let newCaseStudyIndicators = [];
   let newCaseStudyTotalSubSlides = 0;
   let newCaseStudyAutoSlideInterval;
   let newCaseStudyTouchStartX = 0;
   let newCaseStudyTouchEndX = 0;

   function showNewCaseStudySubSlide(index) {
       try {
           const activeCategorySlide = safeQuerySelector('.new-case-study-section .testimonial-category-slide.active');
           if (!activeCategorySlide) return;

           // Handle col elements in the testimonial-sub-carousel
           newCaseStudySubSlides = safeQuerySelectorAll('.new-case-study-section .testimonial-sub-carousel .col', activeCategorySlide);
           newCaseStudyIndicators = safeQuerySelectorAll('.new-case-study-section .sub-indicator', activeCategorySlide);
           newCaseStudyTotalSubSlides = newCaseStudySubSlides.length;

           if (newCaseStudyTotalSubSlides === 0) return;

           newCaseStudySubSlides.forEach(slide => {
               if (slide) {
                   slide.classList.remove('active');
                   slide.style.display = 'none';
                   slide.style.opacity = '0';
                   slide.style.visibility = 'hidden';
               }
           });
           
           newCaseStudyIndicators.forEach(dot => {
               if (dot) dot.classList.remove('active');
           });

           if (newCaseStudySubSlides[index]) {
               newCaseStudySubSlides[index].classList.add('active');
               newCaseStudySubSlides[index].style.display = 'block';
               newCaseStudySubSlides[index].style.opacity = '1';
               newCaseStudySubSlides[index].style.visibility = 'visible';
           }
           
           if (newCaseStudyIndicators[index]) {
               newCaseStudyIndicators[index].classList.add('active');
           }

           newCaseStudyCurrentSubSlide = index;
       } catch (error) {
           console.error('Error in new case study showSubSlide:', error);
       }
   }

   function nextNewCaseStudySubSlide() {
       if (newCaseStudyTotalSubSlides > 0) {
           const next = (newCaseStudyCurrentSubSlide + 1) % newCaseStudyTotalSubSlides;
           showNewCaseStudySubSlide(next);
       }
   }

   function prevNewCaseStudySubSlide() {
       if (newCaseStudyTotalSubSlides > 0) {
           const prev = (newCaseStudyCurrentSubSlide - 1 + newCaseStudyTotalSubSlides) % newCaseStudyTotalSubSlides;
           showNewCaseStudySubSlide(prev);
       }
   }

   function setupNewCaseStudySwipe(slideWrapper) {
       try {
           if (!slideWrapper) return;
          
           // Remove existing event listeners to prevent duplicates
           slideWrapper.removeEventListener('touchstart', handleNewCaseStudyTouchStart);
           slideWrapper.removeEventListener('touchend', handleNewCaseStudyTouchEnd);
          
           // Add new event listeners
           slideWrapper.addEventListener('touchstart', handleNewCaseStudyTouchStart);
           slideWrapper.addEventListener('touchend', handleNewCaseStudyTouchEnd);
       } catch (error) {
           console.error('Error in setupNewCaseStudySwipe:', error);
       }
   }

   function handleNewCaseStudyTouchStart(e) {
       try {
           newCaseStudyTouchStartX = e.changedTouches[0].screenX;
       } catch (error) {
           console.error('Error in handleNewCaseStudyTouchStart:', error);
       }
   }

   function handleNewCaseStudyTouchEnd(e) {
       try {
           newCaseStudyTouchEndX = e.changedTouches[0].screenX;
           if (newCaseStudyTouchEndX < newCaseStudyTouchStartX - 40) nextNewCaseStudySubSlide();
           if (newCaseStudyTouchEndX > newCaseStudyTouchStartX + 40) prevNewCaseStudySubSlide();
       } catch (error) {
           console.error('Error in handleNewCaseStudyTouchEnd:', error);
       }
   }

   function startNewCaseStudyAutoSlide() {
       try {
           if (window.innerWidth < 992) { // 992px breakpoint for new case study
               clearInterval(newCaseStudyAutoSlideInterval);
               newCaseStudyAutoSlideInterval = setInterval(nextNewCaseStudySubSlide, NEW_CASE_STUDY_AUTO_SLIDE_DELAY);
           }
       } catch (error) {
           console.error('Error in startNewCaseStudyAutoSlide:', error);
       }
   }

   function stopNewCaseStudyAutoSlide() {
       try {
           clearInterval(newCaseStudyAutoSlideInterval);
       } catch (error) {
           console.error('Error in stopNewCaseStudyAutoSlide:', error);
       }
   }

   function initNewCaseStudyMobileSlider() {
       try {
           if (window.innerWidth >= 992) { // 992px breakpoint for new case study
               stopNewCaseStudyAutoSlide();
               return;
           }

           const activeCategorySlide = safeQuerySelector('.new-case-study-section .testimonial-category-slide.active');
           if (!activeCategorySlide) return;

           newCaseStudySubSlides = safeQuerySelectorAll('.new-case-study-section .testimonial-sub-carousel .col', activeCategorySlide);
           newCaseStudyIndicators = safeQuerySelectorAll('.new-case-study-section .sub-indicator', activeCategorySlide);
           newCaseStudyTotalSubSlides = newCaseStudySubSlides.length;

           if (newCaseStudyTotalSubSlides === 0) return;

           // Ensure first card is visible on mobile
           showNewCaseStudySubSlide(0); // show first
           
           // Start auto-slide
           startNewCaseStudyAutoSlide();
           
           // Setup swipe functionality
           setupNewCaseStudySwipe(activeCategorySlide);
       } catch (error) {
           console.error('Error in initNewCaseStudyMobileSlider:', error);
       }
   }

   // Initialize on page load
   window.addEventListener('load', function() {
       try {
           // Initialize the first category for new case study section
           const firstCategoryButton = safeQuerySelector('.new-case-study-section .category-btn');
           if (firstCategoryButton) {
               const category = firstCategoryButton.getAttribute('data-category');
               if (category) {
                   showNewCaseStudyCategory(category);
               }
           }
           
           // Initialize mobile slider
           initNewCaseStudyMobileSlider();
       } catch (error) {
           console.error('Error in new case study initialization:', error);
       }
   });
   window.addEventListener('resize', initNewCaseStudyMobileSlider);

   // Add specific function for new case study indicators
   window.showNewCaseStudySubSlide = function(index) {
       showNewCaseStudySubSlide(index);
   };

   // Override functions for new case study section
   const originalShowTestimonialCategory = window.showTestimonialCategory;
   window.showTestimonialCategory = function(category) {
       try {
           originalShowTestimonialCategory(category);
           if (window.innerWidth < 992) { // 992px breakpoint for new case study
               setTimeout(initNewCaseStudyMobileSlider, 100);
           }
       } catch (error) {
           console.error('Error in overridden showTestimonialCategory for new case study:', error);
       }
   };

   // Override showSubSlide for new case study section
   const originalShowSubSlide = window.showSubSlide;
   window.showSubSlide = function (index) {
       try {
           originalShowSubSlide(index);
           if (window.innerWidth < 992) { // 992px breakpoint for new case study
               clearInterval(newCaseStudyAutoSlideInterval);
               newCaseStudyAutoSlideInterval = setInterval(nextNewCaseStudySubSlide, NEW_CASE_STUDY_AUTO_SLIDE_DELAY);
           }
       } catch (error) {
           console.error('Error in overridden showSubSlide for new case study:', error);
       }
   };
})();


// ========================================
// NEW CASE STUDY SECTION - SEPARATE FUNCTIONS
// ========================================

// function showNewCaseStudyCategory(category) {
//   try {
//       console.log(`Switching to new case study category: ${category}`);
     
//       const newCaseStudySection = safeQuerySelector('.new-case-study-section');
//       if (!newCaseStudySection) {
//           console.warn('New case study section not found');
//           return;
//       }
     
//       const categoryButtons = safeQuerySelectorAll('.new-case-study-section .category-btn');
//       categoryButtons.forEach(btn => {
//           if (btn) btn.classList.remove('active');
//       });
     
//       const activeButton = safeQuerySelector(`.new-case-study-section .category-btn[data-category="${category}"]`);
//       if (activeButton) {
//           activeButton.classList.add('active');
//           console.log('Active button set for category:', category);
//       } else {
//           console.warn(`New case study category button not found: ${category}`);
//       }
     
//       const categorySlides = safeQuerySelectorAll('.new-case-study-section .testimonial-category-slide');
//       categorySlides.forEach(slide => {
//           if (slide) slide.classList.remove('active');
//       });
     
//       const targetSlide = safeQuerySelector(`.new-case-study-section .testimonial-category-slide[data-category="${category}"]`);
//       if (targetSlide) {
//           targetSlide.classList.add('active');
//           console.log('Target slide activated for category:', category);
          
//           if (typeof newCaseStudyCurrentSubSlide !== 'undefined') {
//               newCaseStudyCurrentSubSlide = 0;
//           }
          
//           setTimeout(() => {
//               showNewCaseStudySubSlide(0);
//           }, 100);
//       } else {
//           console.warn(`New case study category slide not found: ${category}`);
//       }
     
//       if (typeof newCaseStudyCurrentCategory !== 'undefined') {
//           newCaseStudyCurrentCategory = category;
//       }
      
//       console.log(`New case study category switched successfully to: ${category}`);
//   } catch (error) {
//       console.error('Error in showNewCaseStudyCategory:', error);
//   }
// }

// function showNewCaseStudySubSlide(index) {
//   try {
//       console.log(`Showing new case study sub slide: ${index}`);
      
//       const activeCategorySlide = safeQuerySelector('.new-case-study-section .testimonial-category-slide.active');
//       if (!activeCategorySlide) {
//           console.warn('No active category slide found in new case study section');
//           return;
//       }

//       const colSlides = safeQuerySelectorAll('.new-case-study-section .testimonial-sub-carousel .col', activeCategorySlide);
//       const indicators = safeQuerySelectorAll('.new-case-study-section .sub-indicator', activeCategorySlide);
      
//       if (colSlides.length === 0) {
//           console.warn('No col slides found in new case study section');
//           return;
//       }

//       colSlides.forEach(slide => {
//           if (slide) {
//               slide.classList.remove('active');
//               slide.style.display = 'none';
//               slide.style.opacity = '0';
//               slide.style.visibility = 'hidden';
//           }
//       });
      
//       indicators.forEach(dot => {
//           if (dot) dot.classList.remove('active');
//       });

//       if (colSlides[index]) {
//           colSlides[index].classList.add('active');
//           colSlides[index].style.display = 'block';
//           colSlides[index].style.opacity = '1';
//           colSlides[index].style.visibility = 'visible';
//           console.log(`Col slide ${index} activated`);
//       }
      
//       if (indicators[index]) {
//           indicators[index].classList.add('active');
//           console.log(`Indicator ${index} activated`);
//       }

//       if (typeof newCaseStudyCurrentSubSlide !== 'undefined') {
//           newCaseStudyCurrentSubSlide = index;
//       }
      
//       console.log(`New case study sub slide changed to: ${index}`);
//   } catch (error) {
//       console.error('Error in showNewCaseStudySubSlide:', error);
//   }
// }

// window.showNewCaseStudyCategory = showNewCaseStudyCategory;
// window.showNewCaseStudySubSlide = showNewCaseStudySubSlide;


// ========================================
// INTEGRATION SECTION - ENHANCED FOR LIVE PAGES
// ========================================

(function() {
  try {
      // Global error handlers for integration section
    //   window.addEventListener('error', function(e) {
    //       console.error('Integration section error caught:', e.error);
    //   });

      window.addEventListener('unhandledrejection', function(e) {
          console.error('Integration section unhandled promise rejection:', e.reason);
      });

      // Integration section utility functions
      function safeQuerySelector(selector, parent = document) {
         try {
    if (!selector || typeof selector !== 'string') return [];
    return parent.querySelectorAll(selector) || [];
  } catch {
    return [];
  }
      }

      function safeQuerySelectorAll(selector, parent = document) {
          try {
              if (!selector || typeof selector !== 'string') {
                  console.warn('Invalid selector provided:', selector);
                  return [];
              }
              const elements = parent.querySelectorAll(selector);
              if (elements.length === 0) {
                  console.warn(`No elements found: ${selector}`);
              }
              return elements;
          } catch (error) {
              console.warn(`Error finding elements ${selector}:`, error);
              return [];
          }
      }

      // Enhanced initialization check function
      function isElementReady(selector, maxAttempts = 10) {
          return new Promise((resolve) => {
              let attempts = 0;
              const checkElement = () => {
                  const element = safeQuerySelector(selector);
                  if (element) {
                      resolve(true);
                  } else if (attempts < maxAttempts) {
                      attempts++;
                      setTimeout(checkElement, 100);
                  } else {
                      console.warn(`Element ${selector} not ready after ${maxAttempts} attempts`);
                      resolve(false);
                  }
              };
              checkElement();
          });
      }

      // Integration tab functionality
      function showIntegrationTab(tabName) {
          try {
              console.log(`Switching to integration tab: ${tabName}`);
              
              // Remove active class from all integration tab buttons
              const tabButtons = safeQuerySelectorAll('.integration-tab-btn');
              tabButtons.forEach(btn => {
                  if (btn) btn.classList.remove('active');
              });
              
              // Add active class to clicked button
              const activeButton = safeQuerySelector(`.integration-tab-btn[data-integration="${tabName}"]`);
              if (activeButton) {
                  activeButton.classList.add('active');
              } else {
                  console.warn(`Integration tab button not found: ${tabName}`);
              }
              
              // Hide all integration tab content
              const tabContents = safeQuerySelectorAll('.integration-tab-content');
              tabContents.forEach(content => {
                  if (content) content.classList.remove('active');
              });
              
              // Show the selected tab content
              const targetContent = safeQuerySelector(`.integration-tab-content[data-integration="${tabName}"]`);
              if (targetContent) {
                  targetContent.classList.add('active');
                  
                  // Initialize partner selection for this tab
                  setTimeout(() => {
                      initializePartnerSelection();
                  }, 100);
              } else {
                  console.warn(`Integration tab content not found: ${tabName}`);
              }
              
          } catch (error) {
              console.error('Error in showIntegrationTab:', error);
          }
      }

      // Initialize partner selection within current tab
      function initializePartnerSelection() {
          try {
              const activeTabContent = safeQuerySelector('.integration-tab-content.active');
              if (!activeTabContent) return;
              
              // Get all partner buttons in the active tab
              const partnerButtons = safeQuerySelectorAll('.integration-partner', activeTabContent);
              const partnerContents = safeQuerySelectorAll('.integration-partner-content', activeTabContent);
              
              if (partnerButtons.length === 0) {
                  console.warn('No partner buttons found in active tab');
                  return;
              }
              
              // Remove active class from all partner buttons and content
              partnerButtons.forEach(btn => {
                  if (btn) btn.classList.remove('active');
              });
              
              partnerContents.forEach(content => {
                  if (content) content.classList.remove('active');
              });
              
              // Set first partner as active
              const firstPartner = partnerButtons[0];
              if (firstPartner) {
                  const partnerName = firstPartner.getAttribute('data-partner');
                  if (partnerName) {
                      firstPartner.classList.add('active');
                      showPartnerContent(partnerName);
                  }
              }
              
              // Add click listeners to all partner buttons
              partnerButtons.forEach(btn => {
                  if (btn) {
                      // Remove existing listeners to prevent duplicates
                      btn.removeEventListener('click', btn._partnerClickHandler);
                      
                      // Create new click handler
                      btn._partnerClickHandler = function() {
                          try {
                              const partnerName = this.getAttribute('data-partner');
                              if (partnerName) {
                                  // Remove active from all partner buttons
                                  partnerButtons.forEach(b => {
                                      if (b) b.classList.remove('active');
                                  });
                                  
                                  // Add active to clicked button
                                  this.classList.add('active');
                                  
                                  // Show partner content
                                  showPartnerContent(partnerName);
                              }
                          } catch (error) {
                              console.error('Error in partner button click:', error);
                          }
                      };
                      
                      btn.addEventListener('click', btn._partnerClickHandler);
                  }
              });
              
          } catch (error) {
              console.error('Error in initializePartnerSelection:', error);
          }
      }

      // Show partner content
      function showPartnerContent(partnerName) {
          try {
              console.log(`Showing partner content: ${partnerName}`);
              
              const activeTabContent = safeQuerySelector('.integration-tab-content.active');
              if (!activeTabContent) {
                  console.warn('No active tab content found');
                  return;
              }
              
              // Hide all partner content
              const partnerContents = safeQuerySelectorAll('.integration-partner-content', activeTabContent);
              partnerContents.forEach(content => {
                  if (content) content.classList.remove('active');
              });
              
              // Show the selected partner content
              const targetContent = safeQuerySelector(`.integration-partner-content[data-partner="${partnerName}"]`, activeTabContent);
              if (targetContent) {
                  targetContent.classList.add('active');
                  console.log(`Partner content activated: ${partnerName}`);
              } else {
                  console.warn(`Partner content not found: ${partnerName}`);
              }
              
          } catch (error) {
              console.error('Error in showPartnerContent:', error);
          }
      }

      // Initialize CTA buttons
      function initializeCTAButtons() {
          try {
              const ctaButtons = safeQuerySelectorAll('.integration-cta .btn');
              
              ctaButtons.forEach(btn => {
                  if (btn) {
                      // Remove existing listeners to prevent duplicates
                      btn.removeEventListener('click', btn._ctaClickHandler);
                      
                      // Create new click handler
                      btn._ctaClickHandler = function(e) {
                          try {
                              e.preventDefault();
                              const href = this.getAttribute('href');
                              if (href && href !== '#') {
                                  window.open(href, '_blank');
                              } else {
                                  console.log('CTA button clicked:', this.textContent);
                                  // Add your CTA functionality here
                              }
                          } catch (error) {
                              console.error('Error in CTA button click:', error);
                          }
                      };
                      
                      btn.addEventListener('click', btn._ctaClickHandler);
                  }
              });
              
          } catch (error) {
              console.error('Error in initializeCTAButtons:', error);
          }
      }

      // Main initialization function for integration section
      function initializeNewIntegrationSection() {
           try {
    if (!selector || typeof selector !== 'string') return [];
    return parent.querySelectorAll(selector) || [];
  } catch {
    return [];
  }


          
      }

      // Multiple initialization strategies for integration section
      function initializeWithRetry(maxRetries = 5) {
          let retryCount = 0;
          
          const attemptInitialization = () => {
              try {
                  console.log(`Integration initialization attempt ${retryCount + 1}/${maxRetries}`);
                  initializeNewIntegrationSection();
              } catch (error) {
                  console.error(`Integration initialization attempt ${retryCount + 1} failed:`, error);
                  retryCount++;
                  
                  if (retryCount < maxRetries) {
                      setTimeout(attemptInitialization, 1000);
                  } else {
                      console.error('All integration initialization attempts failed');
                  }
              }
          };
          
          attemptInitialization();
      }

      // Make functions globally available
      window.showIntegrationTab = showIntegrationTab;
      window.initializeNewIntegrationSection = initializeNewIntegrationSection;

      // Initialize with multiple strategies
      if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function() {
              console.log('DOMContentLoaded - Initializing integration section...');
              setTimeout(initializeWithRetry, 100);
          });
      } else {
          console.log('Document already loaded - Initializing integration section...');
          setTimeout(initializeWithRetry, 100);
      }
      
      // Window load backup
      window.addEventListener('load', function() {
          console.log('Window load - Backup integration initialization...');
          setTimeout(initializeWithRetry, 200);
      });
      
      // Additional backup for slow-loading pages
      setTimeout(function() {
          console.log('Delayed integration initialization check...');
          initializeWithRetry();
      }, 3000);
      
  } catch (error) {
      console.error('Error in integration section functionality:', error);
  }
})();


// ========================================
// FINAL ENHANCEMENTS FOR 100% LIVE PAGE COMPATIBILITY
// ========================================

// Enhanced global error handling
// window.addEventListener('error', function(e) {
//   console.error('Global error caught:', e.error);
//   e.preventDefault();
// });

// Enhanced unhandled promise rejection handling
window.addEventListener('unhandledrejection', function(e) {
  console.error('Unhandled promise rejection:', e.reason);
  // Prevent unhandled promise rejections from breaking the page
  e.preventDefault();
});

// Final initialization check
window.addEventListener('load', function() {
  console.log('Final initialization check for all sections...');
  
  // Verify all sections are working
  setTimeout(() => {
      try {
          // Check feature carousel
          const featureSlides = document.querySelectorAll('.feature-carousel-slide');
          console.log('Feature carousel slides found:', featureSlides.length);
          
          // Check testimonial sections
          const testimonialSlides = document.querySelectorAll('.testimonial-category-slide');
          console.log('Testimonial slides found:', testimonialSlides.length);
          
          // Check specialty section
          const specialtyButtons = document.querySelectorAll('.speciality-btn');
          console.log('Specialty buttons found:', specialtyButtons.length);
          
          // Check video carousel
          const playButtons = document.querySelectorAll('.play-button');
          console.log('Video play buttons found:', playButtons.length);
          
          // Check new case study section
          const newCaseStudySection = document.querySelector('.new-case-study-section');
          console.log('New case study section found:', !!newCaseStudySection);
          
          // Check integration section
          const integrationSection = document.querySelector('.new-integration-section');
          console.log('Integration section found:', !!integrationSection);
          
          console.log('All sections verified successfully!');
          
      } catch (error) {
          console.error('Error in final verification:', error);
      }
  }, 2000);
});

console.log('new-ad-section.js loaded successfully - 100% LIVE PAGE COMPATIBLE');


// ------------------------------------------------------
// AUTO-SCROLL FEATURE BUTTON ROW ON MOBILE (<992px)
// Ensures the active button in .tab.tab3 is always visible
// ------------------------------------------------------
(function () {
    // find the horizontal button row (mobile)
    const slider =
      document.querySelector('.new-seature-section-carousel .tablet-feature .tab.tab3') ||
      document.querySelector('.tablet-feature .tab.tab3') ||
      document.querySelector('.tab.tab3');
  
    if (!slider) return;
  
    // Make sure the active button is visible inside the horizontal scroller
    function ensureActiveVisible(pad = 16) {
      if (window.innerWidth >= 992) return; // only for mobile/tablet
      const active =
        slider.querySelector('.feature-button-mobile.active') ||
        slider.querySelector('.feature-button.active');
      if (!active) return;
  
      const c = slider.getBoundingClientRect();
      const r = active.getBoundingClientRect();
  
      // If active is clipped on the left
      if (r.left < c.left + pad) {
        const delta = (c.left + pad) - r.left;
        slider.scrollTo({ left: slider.scrollLeft - delta, behavior: 'smooth' });
      }
      // If active is clipped on the right
      else if (r.right > c.right - pad) {
        const delta = r.right - (c.right - pad);
        slider.scrollTo({ left: slider.scrollLeft + delta, behavior: 'smooth' });
      }
    }
  
    // When anything that controls the slide is clicked, re-check visibility
    document.addEventListener('click', (e) => {
      if (
        e.target.closest('.feature-button-mobile') ||
        e.target.closest('.carousel-nav-dot') ||
        e.target.closest('.new-mobile-section-caroucel .carousel-item')
      ) {
        // let existing handlers toggle .active, then adjust
        setTimeout(ensureActiveVisible, 0);
      }
    });
  
    // Also react if some other script toggles .active class
    const mo = new MutationObserver((list) => {
      for (const m of list) {
        if (
          m.type === 'attributes' &&
          m.attributeName === 'class' &&
          (m.target.classList?.contains('feature-button-mobile') ||
           m.target.classList?.contains('feature-button'))
        ) {
          ensureActiveVisible();
          break;
        }
      }
    });
    slider.querySelectorAll('.feature-button-mobile, .feature-button')
          .forEach(el => mo.observe(el, { attributes: true }));
  
    // On load & when resizing under 992px
    window.addEventListener('load', ensureActiveVisible);
    window.addEventListener('resize', ensureActiveVisible);
  
    // initial nudge
    ensureActiveVisible();
  })();

  

  // ------------------------------
// FEATURE BUTTON + DOT + CAROUSEL SYNC
// ------------------------------
(function () {

    // ============================================================
    // ===== PERF-FIX 2 of 2 — OLD CODE, COMMENTED OUT ============
    // WHY: same unbounded-retry pattern as PERF-FIX 1. If any of the three
    // element groups is missing (e.g. on a breakpoint where the mobile carousel
    // is not rendered), this re-scheduled itself every 200ms forever — 5 timer
    // callbacks per second for the life of the page. Combined with the video
    // carousel loop this kept the page permanently "busy", which is what makes
    // Lighthouse cut its trace and report NO_LCP.
    // TO REVERT: comment out the NEW CODE below and uncomment this block
    // (remember to also remove the `var _fcsAttempts = 0;` line).
    //
    //     function initFeatureCarouselSync() {
    //       const buttons = document.querySelectorAll(".feature-button-mobile");
    //       const carouselItems = document.querySelectorAll(".new-mobile-section-caroucel .carousel-item");
    //       const dots = document.querySelectorAll(".carousel-nav-dot");
    //
    //       if (!buttons.length || !carouselItems.length || !dots.length) {
    //         // elements not yet available → retry after 200ms
    //         setTimeout(initFeatureCarouselSync, 200);
    //         return;
    //       }
    //       ... (rest of function unchanged, see NEW CODE below)
    // ===== END OLD CODE =========================================


    // ===== PERF-FIX 2 of 2 — NEW CODE ===========================
    // Retries capped at 25 x 200ms = 5 seconds, then it gives up quietly.
    // Everything below the guard is byte-for-byte identical to the original.
    var _fcsAttempts = 0;

    function initFeatureCarouselSync() {
      const buttons = document.querySelectorAll(".feature-button-mobile");
      const carouselItems = document.querySelectorAll(".new-mobile-section-caroucel .carousel-item");
      const dots = document.querySelectorAll(".carousel-nav-dot");
  
      if (!buttons.length || !carouselItems.length || !dots.length) {
        // elements not yet available → retry after 200ms, but STOP after 5s
        if (_fcsAttempts < 25) {
          _fcsAttempts++;
          setTimeout(initFeatureCarouselSync, 200);
        }
        return;
      }
    // ===== END NEW CODE =========================================
    // ============================================================
  
      function activate(index) {
        // Buttons
        buttons.forEach(b => b.classList.remove("active"));
        if (buttons[index]) buttons[index].classList.add("active");
  
        // Carousel items
        carouselItems.forEach(item => item.classList.remove("active"));
        if (carouselItems[index]) carouselItems[index].classList.add("active");
  
        // Dots
        dots.forEach(d => d.classList.remove("active"));
        if (dots[index]) dots[index].classList.add("active");
      }
  
      // Button click
      buttons.forEach((btn, index) => {
        btn.addEventListener("click", () => activate(index));
      });
  
      // Dot click
      dots.forEach((dot, index) => {
        dot.addEventListener("click", () => activate(index));
      });
  
      // Initialize with first item active
      activate(0);
      console.log("[FeatureCarouselSync] initialized");
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initFeatureCarouselSync);
    } else {
      initFeatureCarouselSync();
    }
  })();

  

// Video modal script for popup modal

// ==================== VIDEO MODAL HANDLER ====================
document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("videoModal");
  const modalClose = document.getElementById("modalClose"); // close button inside modal
  const videoFrame = document.getElementById("videoFrame");
  const videoCards = document.querySelectorAll(".video-card");

  if (!modal || !videoFrame || videoCards.length === 0) return;

  // Helper: set background thumbnail if data-thumbnail-url is provided
  function setThumbnail(card) {
    const thumbnailUrl = card.dataset.thumbnailUrl;
    if (thumbnailUrl) {
      card.style.setProperty("--bg-image", `url('${thumbnailUrl}')`);
    }
  }

  // Initialize thumbnails
  videoCards.forEach(card => setThumbnail(card));

  // Close modal + stop video playback
  function closeModal() {
    modal.style.display = "none";
    videoFrame.removeAttribute("src"); // clear to fully stop playback
  }

  // Open modal when clicking on a video card
  videoCards.forEach(card => {
    card.addEventListener("click", () => {
      const videoUrl = card.dataset.videoUrl;
      if (!videoUrl) return;
      modal.style.display = "block";
      videoFrame.src = videoUrl;
    });
  });

  // Close on close button
  if (modalClose) {
    modalClose.addEventListener("click", closeModal);
  }

  // Close when clicking outside modal content
  window.addEventListener("click", (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });
});





// ==================== VIDEO MODAL HANDLER ====================
document.addEventListener("DOMContentLoaded", () => {
  // Select the modal and its components
  const modal = document.getElementById("videoModal");
  const modalClose = document.getElementById("modalClose");
  const videoFrame = document.getElementById("videoFrame");

  // Select ALL elements that should open the modal
  const videoCards = document.querySelectorAll(".video-card, .ehr-watch-video-btn button");

  if (!modal || !videoFrame || videoCards.length === 0) return;

  // Function to close the modal and stop the video
  function closeModal() {
    modal.style.display = "none";
    videoFrame.src = ""; // Stop the video from playing in the background
  }

  // Add a single click event listener for ALL selected elements
  videoCards.forEach(element => {
    element.addEventListener("click", () => {
      const videoUrl = element.dataset.videoUrl;
      if (!videoUrl) return;

      // Close any potential previous video before opening a new one
      closeModal();

      // Open the modal and set the video source
      modal.style.display = "block";
      videoFrame.src = videoUrl;
    });
  });

  // Event listener for the modal's close button
  if (modalClose) {
    modalClose.addEventListener("click", closeModal);
  }

  // Event listener for clicking outside the modal
  window.addEventListener("click", (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });
});




// ==================== VIDEO CAROUSEL HOVER/RESET pause script ====================
(function () {
  const track = document.querySelector(".video-carousel-track");
  const cards = document.querySelectorAll(".video-card");

  if (!track || cards.length === 0) return; // Safety check

  let pauseTimeout;

  cards.forEach(card => {
    card.addEventListener("mouseenter", () => {
      // Pause auto-scroll immediately
      track.classList.add("paused");
      track.style.transform = "translateX(0)"; // reset to first card

      // After 3s, resume auto-scroll from beginning
      clearTimeout(pauseTimeout);
      pauseTimeout = setTimeout(() => {
        track.classList.remove("paused");
        track.style.removeProperty("transform"); // let CSS handle animation
      }, 3000);
    });
  });
})();




// ==================== VIDEO CAROUSEL: RESTART FROM FIRST CARD ====================
(function ensureRestartFromFirstCard() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ensureRestartFromFirstCard);
    return;
  }

  const track = document.querySelector(".video-carousel-track");
  const wrapper =
    track?.closest(".video-carousel-wrapper") ||
    document.querySelector(".video-carousel-wrapper");

  if (!track || !wrapper) return; // Safety check: exit if not found

  function resetToStart() {
    // 1) Reset any manual scroll
    wrapper.scrollTo({ left: 0, behavior: "auto" });

    // 2) Stop animation + snap to first card
    const prevAnimation = getComputedStyle(track).animation;
    track.style.animation = "none";
    track.style.transform = "translateX(0)";
    void track.offsetWidth; // force reflow

    // 3) Restart animation (autoscroll resumes cleanly)
    track.style.animation = prevAnimation;
    track.style.removeProperty("transform");
  }

  // Watch when ".paused" is removed → restart from beginning
  const observer = new MutationObserver(() => {
    if (!track.classList.contains("paused")) {
      setTimeout(resetToStart, 0);
    }
  });

  observer.observe(track, { attributes: true, attributeFilter: ["class"] });
})();



// ==================== VIDEO MODAL (HTML5 <video>) ====================
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("videoModal");
  const modalClose = document.getElementById("modalClose");
  const modalVideo = document.getElementById("modalVideo");

  if (!modal || !modalClose || !modalVideo) return; // Safety check

  function openModal(videoSrc) {
    if (videoSrc) {
      modalVideo.src = videoSrc;
      modal.style.display = "flex"; // flex so content centers nicely
      modalVideo.play().catch(err =>
        console.warn("Autoplay blocked by browser:", err)
      );
    }
  }

  function closeModal() {
    modal.style.display = "none";
    modalVideo.pause();
    modalVideo.currentTime = 0;
    modalVideo.removeAttribute("src"); // fully unload
  }

  // Click handler for all video cards
  document.querySelectorAll(".video-card").forEach(card => {
    card.addEventListener("click", function () {
      openModal(this.getAttribute("data-video"));
    });
  });

  // Click handler for all watch buttons
  document.querySelectorAll(".ehr-watch-video-btn button").forEach(btn => {
    btn.addEventListener("click", function () {
      openModal(this.getAttribute("data-video"));
    });
  });

  // Close modal with button
  modalClose.addEventListener("click", closeModal);

  // Close when clicking outside content
  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      closeModal();
    }
  });
});



/* === PAUSE / RESUME video-carousel-track when the video modal opens/closes ===
   Paste this at the end of new-ad-section.js (or before </body>)
*/
(function () {
  // helpers
  function getTracks() {
    return Array.from(document.querySelectorAll('.video-carousel-track'));
  }

  // Pause: add paused class, force transform to 0 and stop animation inline (robust)
  function pauseTracks() {
    const tracks = getTracks();
    if (!tracks.length) return;
    tracks.forEach(t => {
      try {
        // save previous animation (computed or inline) so we can restart cleanly later
        const prev = t.style.animation || getComputedStyle(t).animation || '';
        t.dataset._prevAnimation = prev;

        // apply pause immediately
        t.classList.add('paused');
        t.style.animation = 'none';
        t.style.animationPlayState = 'paused';
        t.style.transform = 'translateX(0)';
        // force reflow so change is immediate
        void t.offsetWidth;
      } catch (err) {
        console.error('pauseTracks error', err);
      }
    });
  }

  // Resume: remove the inline overrides and (optionally) restart animation from the start
  function resumeTracks() {
    const tracks = getTracks();
    if (!tracks.length) return;
    tracks.forEach(t => {
      try {
        t.classList.remove('paused');

        // remove inline pausing props so stylesheet animation applies again
        t.style.removeProperty('transform');
        t.style.removeProperty('animation-play-state');

        // If we saved a previous animation string, restart it fresh so it begins from start
        const prev = t.dataset._prevAnimation;
        if (prev) {
          // restart: set none -> reflow -> restore prev
          t.style.animation = 'none';
          void t.offsetWidth; // reflow
          t.style.animation = prev;
          delete t.dataset._prevAnimation;
        } else {
          // No saved animation, just remove inline animation so CSS takes over
          t.style.removeProperty('animation');
        }
      } catch (err) {
        console.error('resumeTracks error', err);
      }
    });
  }

  // stop any playing video / iframe inside the modal (safe cleanup)
  function stopModalMedia(modalEl) {
    if (!modalEl) return;
    try {
      const ifr = modalEl.querySelector('iframe');
      if (ifr) {
        // removing src stops iframe playback
        ifr.src = '';
      }
      const vid = modalEl.querySelector('video');
      if (vid) {
        vid.pause();
        try { vid.removeAttribute('src'); vid.load(); } catch(e){ /* ignore */ }
      }
    } catch (err) {
      console.error('stopModalMedia error', err);
    }
  }

  // 1) Capture clicks on video cards / play buttons (use capture phase so we run BEFORE other handlers)
  document.addEventListener('click', function (e) {
    try {
      if (e.target.closest && (e.target.closest('.video-card') || e.target.closest('.play-button') || e.target.closest('.ehr-watch-video-btn'))) {
        pauseTracks();
      }
    } catch (err) { /* ignore */ }
  }, true /* capture */);

  // 2) Listen for Bootstrap modal show/hide events (if Bootstrap is used)
  document.addEventListener('shown.bs.modal', function (e) {
    try {
      if (e && e.target && e.target.id === 'videoModal') pauseTracks();
    } catch (err) { /* ignore */ }
  });
  document.addEventListener('hidden.bs.modal', function (e) {
    try {
      if (e && e.target && e.target.id === 'videoModal') {
        stopModalMedia(e.target);
        resumeTracks();
      }
    } catch (err) { /* ignore */ }
  });

  // 3) Fallback: Observe attribute/style/class changes on #videoModal (for non-Bootstrap or custom openers)
  const modal = document.getElementById('videoModal');
  if (modal) {
    const mo = new MutationObserver(function (mutations) {
      try {
        const isOpen = modal.classList.contains('active')
                    || modal.classList.contains('show')
                    || window.getComputedStyle(modal).display !== 'none';
        if (isOpen) pauseTracks();
        else {
          stopModalMedia(modal);
          resumeTracks();
        }
      } catch (err) { /* ignore */ }
    });
    mo.observe(modal, { attributes: true, attributeFilter: ['class', 'style'] });
  }

  // 4) Also wire the close button (#modalClose) as an immediate resume + cleanup
  const closeBtn = document.getElementById('modalClose');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      try {
        // If modal element exists, perform the same cleanup
        const modalEl = document.getElementById('videoModal');
        if (modalEl) stopModalMedia(modalEl);
        resumeTracks();
      } catch (err) { /* ignore */ }
    }, true);
  }

   // 5) NEW: close modal if user clicks outside the modal-content
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) { // clicked on overlay background
        stopModalMedia(modal);
        resumeTracks();
      }
    });
  }

  // Safety: in case other code later force-stops/resumes, expose pause/resume functions
  window.__pauseVideoCarouselTracks = pauseTracks;
  window.__resumeVideoCarouselTracks = resumeTracks;

  // Done.
  console.log('[video-carousel] pause/resume hook installed');
})();



// Star rating js start
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".stars").forEach(starContainer => {
    const rating = parseFloat(starContainer.getAttribute("data-rating")) || 0;
    const maxStars = 5;
    starContainer.innerHTML = "";

    for (let i = 1; i <= maxStars; i++) {
      const star = document.createElement("span");

      if (i <= Math.floor(rating)) {
        // full star
        star.textContent = "★";
        star.classList.add("star", "full");
      } else if (i === Math.floor(rating) + 1 && rating % 1 > 0) {
        // partial star (exact percentage)
        star.textContent = "★";
        star.classList.add("star", "partial");
        star.style.setProperty("--fill", (rating % 1) * 100 + "%");
      } else {
        // empty star
        star.textContent = "★";
        star.classList.add("star", "empty");
      }

      starContainer.appendChild(star);
    }
  });
});


// challeneege new section script for carousel indiactor
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const carouselEl = document.getElementById('challengeCarousel');
    if (!carouselEl) return;

    const carouselInner = carouselEl.querySelector('.carousel-inner');
    const indicators = Array.from(document.querySelectorAll('[data-bs-target="#challengeCarousel"]'));

    // Helper to pause bootstrap if present
    try {
      const bs = bootstrap?.Carousel?.getInstance(carouselEl) || bootstrap?.Carousel?.getOrCreateInstance?.(carouselEl);
      if (bs && typeof bs.pause === 'function') bs.pause();
    } catch (e) { /* ignore if bootstrap not available */ }

    // Ensure items behave like flex children (defensive)
    Array.from(carouselInner.querySelectorAll('.carousel-item')).forEach(it => {
      it.classList.remove('carousel-item-start','carousel-item-end','active','carousel-item-left','carousel-item-right');
    });

    // Scroll the given item into centered view
    function centerItemAtIndex(idx, behavior = 'smooth') {
      const items = Array.from(carouselInner.querySelectorAll('.carousel-item'));
      const item = items[idx];
      if (!item) return;
      const left = Math.max(0, item.offsetLeft - (carouselInner.clientWidth - item.clientWidth) / 2);
      carouselInner.scrollTo({ left, behavior });
    }

    // Update dots based on center-most item
    function updateActiveDotByScroll() {
      const items = Array.from(carouselInner.querySelectorAll('.carousel-item'));
      const center = carouselInner.scrollLeft + (carouselInner.clientWidth / 2);
      let closest = 0, min = Infinity;
      items.forEach((it, i) => {
        const itemCenter = it.offsetLeft + (it.clientWidth / 2);
        const d = Math.abs(center - itemCenter);
        if (d < min) { min = d; closest = i; }
      });
      indicators.forEach((btn, i) => {
        btn.classList.toggle('active', i === closest);
        if (i === closest) btn.setAttribute('aria-current', 'true'); else btn.removeAttribute('aria-current');
      });
    }

    // Throttle helper
    let ticking = false;
    carouselInner.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => { updateActiveDotByScroll(); ticking = false; });
    }, { passive: true });

    // Attach clicks on dots
    indicators.forEach((btn, idx) => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        centerItemAtIndex(idx);
        indicators.forEach((b, i) => b.classList.toggle('active', i === idx));
      });
    });

    // Initial centering
    setTimeout(() => {
      const items = Array.from(carouselInner.querySelectorAll('.carousel-item'));
      const initial = Math.max(0, items.findIndex(el => el.classList.contains('active')));
      centerItemAtIndex(initial || 0, 'auto');
      updateActiveDotByScroll();
    }, 80);

    // Recenter on resize
    let rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(() => {
        const activeIdx = indicators.findIndex(b => b.classList.contains('active'));
        centerItemAtIndex(activeIdx >= 0 ? activeIdx : 0, 'auto');
      }, 120);
    });
  });
})();